import { User, UserArgs, getUsers } from '../assets/ts/data/users'
import useServerData from './use-server-data'

function useUsers(fetchArgs, waitOnParentDependency = false) {
  const {
    data: users,
    error: UserError,
    fetchData: fetchUsers,
    isLoading: UsersAreLoading,
  } = useServerData<User, UserArgs>(
    getUsers,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    UserError,
    UsersAreLoading,
    fetchUsers,
    users,
  }
}

export default useUsers
